import { render, staticRenderFns } from "./customer-order-return-rma.vue?vue&type=template&id=54f41d50&"
import script from "./customer-order-return-rma.vue?vue&type=script&lang=js&"
export * from "./customer-order-return-rma.vue?vue&type=script&lang=js&"
import style0 from "./customer-order-return-rma.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports